import * as React from "react";
import { AllIconNames, Hint } from "react-ui";

import { IterUtils } from "../../../../../Common/IterableUtils";
import { Icon } from "../../Icons/Icon";

import { ChildSpacer, Content, ReadOnlyContent, IconContainer, Root } from "./MultiLineFieldItem.styles";

interface MultiLineFieldItemProps {
    children: React.ReactNode;
    instance: string;
    hint?: string;
    isFocus?: boolean;
    isLast: boolean;
    icon: AllIconNames | undefined;
    onIconClick: (instance: string) => void;
    isReadOnly?: boolean;
}

export function MultiLineFieldItem(props: MultiLineFieldItemProps): JSX.Element {
    const handleOnClick = React.useCallback(() => props.onIconClick?.(props.instance), [props.instance]);

    let children = React.Children.map(props.children ?? [], (child, index) => {
        if (!React.isValidElement<{ autoFocus?: unknown }>(child)) {
            return child;
        }

        let childProps = child.props;
        if (props.isFocus && index === 0) {
            childProps = { ...childProps, autoFocus: true };
        }
        return React.cloneElement(child, childProps);
    });

    children = IterUtils.intersperseFn(children, (_, i) => <ChildSpacer key={`Spacer-${i}`} />);

    if (props.isReadOnly) {
        const childrenForReadOnly = children.map((ch, idx) => (
            <div
                key={idx}
                style={{
                    width: "100%",
                }}>
                {ch}
            </div>
        ));
        return <ReadOnlyContent>{childrenForReadOnly}</ReadOnlyContent>;
    }

    return (
        <Root>
            <Content>{children}</Content>
            {props.icon && (
                <IconContainer onClick={handleOnClick}>
                    <Hint text={props.hint} useWrapper={false}>
                        <Icon name={props.icon} data-tid={`${props.icon}`} />
                    </Hint>
                </IconContainer>
            )}
        </Root>
    );
}
